wbApp.controller('ActionsCtrl', ['$scope', '$modal', '$translate', 'semesterSvc', 'courseSvc', 'securitySvc', 'tenantSettingSvc', 'courseRegistrationSvc',
function ($scope, $modal, $translate, semesterSvc, courseSvc, securitySvc, tenantSettingSvc, courseRegistrationSvc) {

    $scope.isInAccountingBookRole = securitySvc.isInRole('AccountingBook');
    $scope.filteredActions = [];

    function setSelectedAction(action, refresh) {
        $scope.selectedAction = action;

        if (!action && !!$scope.gridSettings.gridInstance) {
            $scope.gridSettings.gridInstance.clearSelection();
        }

        $scope.$broadcast('selectedActionChanged', { action: action, refresh: !!refresh });

    }

    semesterSvc.getDefaultAsync()
        .then(function (semester) {
            $scope.semesterID = semester.id;

            $scope.actions = courseSvc.getAllActionsAsync($scope.semesterID, true);
            $scope.filteredActions = $scope.actions;
            setSelectedAction(null);
        });

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            $scope.actions = courseSvc.getAllActionsAsync($scope.semesterID, true);
            $scope.filteredActions = $scope.actions;
            setSelectedAction(null);
        }
    });

    $scope.$on('onActionShouldRefresh', function (e, data) {
        courseSvc.refreshActionRecord($scope.semesterID, data.action.courseID, $scope.actions, function () {
            if ($scope.selectedAction.courseID === data.action.courseID) {
                setSelectedAction(data.action, true);
                if ($scope.gridSettings.gridInstance) {
                    $scope.gridSettings.gridInstance.selectRows(data.action, false);
                }
            }
        });
    });

    $scope.getSemesterPercentFilled = function () {
        return ($scope.getSemesterFilled() / $scope.getSemesterCapacity()) * 100;
    }

    $scope.getSemesterFilled = function () {
        if (!!$scope.filteredActions) {
            return _.sumBy($scope.filteredActions, 'filled');
        }
        return 0;
    }

    $scope.getSemesterCapacity = function () {
        if (!!$scope.filteredActions) {
            return _.sumBy($scope.filteredActions, 'capacity');
        }
        return 100;
    }

    $scope.onFilterApplied = function (rows) {
        $scope.filteredActions = rows;
    }

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            $scope.actions = courseSvc.getAllActionsAsync($scope.semesterID, true);
        }
        setSelectedAction(null);
    }

    $scope.gridSettings = {
        name: 'actions',
        columns: [
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '170px' },
            { dataField: 'abbreviation', caption: $translate.instant("TXT_LBL_ABBREVIATION"), dataType: 'string', width: '130px' },
            { dataField: 'subjectName', caption: $translate.instant('TXT_LBL_ACTION_CATEGORY'), dataType: 'string', sortOrder: 'asc' },
            { dataField: 'firstLesson', caption: $translate.instant('TXT_MENU_SCHEDULE'), dataType: 'date', format: { raw: "EEE - dd.MM. HH:mm" }, width: '140px' },
            { dataField: 'teacher', caption: $translate.instant('TXT_LBL_EMPLOYEE'), dataType: 'string', width: '170px' },
            { dataField: 'capacity', caption: $translate.instant('TXT_LBL_CAPACITY'), dataType: 'number', width: '70px' },
            { dataField: 'filled', caption: $translate.instant('TXT_LBL_FILLED'), dataType: 'number', width: '80px' },
            { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format:'currency', precision: 2, width: '100px' },
            { dataField: 'allowRegistration', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
        ],
        customCommands: [{
            text: $translate.instant('TXT_MENU_RESEND_COURSE_REGISTRATION_NOTIFICATION'),
            isVisible: function () { return securitySvc.isInRole('CourseRegistration'); },
            callback: function (data) { onResendCourseRegistrationNotification(data.courseID); }
        }]
    }

    function onResendCourseRegistrationNotification(courseID) {
        var courseRegistrations = courseRegistrationSvc.getAllForCourse(courseID);
        courseRegistrations.$promise.then(function (data) {
            _.forEach(data, function (courseRegistration) {
                courseRegistrationSvc.sendRegistrationNotification(courseRegistration.courseRegistrationID);
            });
        });
    }
    
    $scope.selectedAction = {};

    $scope.onRowSelected = function (data) {
        $scope.selectedAction = data;
        setSelectedAction($scope.selectedAction);
    }

    $scope.onRowCopy = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.actions;
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.model.courseID = 0;           
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.actions;
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onActionSave = function (model) {
                setSelectedAction(model, true);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.actions;
            detailDialogPromise.$scope.model = courseSvc.createNew($scope.semesterID, true);            
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        courseSvc.remove(data, $scope.actions, function () {
            $scope.selectedAction = null;
            setSelectedAction(null);
        });
    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "actions/actions/actions-detail-tabs/detail.html"
    }, {
        title: 'TXT_LBL_STUDENTS',
        template: 'actions/actions/actions-detail-tabs/students.html'
    }, {
        title: 'TXT_MENU_SCHEDULE',
        template: 'actions/actions/actions-detail-tabs/schedule.html'
    }];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

    var detailDialogPromise = $modal({
        templateUrl: 'actions/actions/detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
